import { taggedTemplateLiteral as _taggedTemplateLiteral, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MediaQuery from '../../_virtual/react-responsive.js';
import { Nav } from '../Nav/index.js';
import { MemberDropdown, MobileTopMenu } from '../MemberDropdown/index.js';
import SidePanel from '../SidePanel/index.js';
import { SearchIconMobile, HamburgerIcon } from '../Icons/index.js';
import { MobileButtonGroup, BurgerBox, AuthBox, MenuBox } from './styled.js';
import getPgaTld from '../../getPgaTld.js';

var _templateObject;
styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n  flex-grow: 0;\n"])));
var pgaTld = getPgaTld();
var MobileNavigation = /*#__PURE__*/function (_Component) {
  function MobileNavigation(props) {
    var _this;
    _classCallCheck(this, MobileNavigation);
    _this = _callSuper(this, MobileNavigation, [props]);
    _this.state = {
      open: false
    };
    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }
  _inherits(MobileNavigation, _Component);
  return _createClass(MobileNavigation, [{
    key: "onClick",
    value: function onClick() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        options = _this$props.options,
        linkComponent = _this$props.linkComponent,
        menuOptions = _this$props.menuOptions,
        me = _this$props.me,
        comp = _this$props.comp,
        b = _this$props.b,
        l = _this$props.l,
        isLoggedIn = _this$props.isLoggedIn,
        meEmailMigrationData = _this$props.meEmailMigrationData,
        onToggleDoNotShowAgain = _this$props.onToggleDoNotShowAgain;
      return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(MobileButtonGroup, null, /*#__PURE__*/React__default.createElement("a", {
        href: "http://resources.".concat(pgaTld)
      }, /*#__PURE__*/React__default.createElement(SearchIconMobile, null)), /*#__PURE__*/React__default.createElement(BurgerBox, {
        onClick: this.onClick
      }, /*#__PURE__*/React__default.createElement(HamburgerIcon, null))), /*#__PURE__*/React__default.createElement(SidePanel, {
        open: this.state.open,
        onClose: this.onClick
      }, /*#__PURE__*/React__default.createElement(AuthBox, null, /*#__PURE__*/React__default.createElement(MediaQuery, {
        minWidth: 992
      }, /*#__PURE__*/React__default.createElement(MemberDropdown, {
        me: me,
        options: options,
        menuOptions: menuOptions,
        flat: true
      })), /*#__PURE__*/React__default.createElement(MediaQuery, {
        maxWidth: 991
      }, /*#__PURE__*/React__default.createElement(MobileTopMenu, {
        me: me,
        menuOptions: menuOptions,
        comp: comp
      }))), /*#__PURE__*/React__default.createElement(MenuBox, null, /*#__PURE__*/React__default.createElement(Nav, {
        options: options,
        comp: linkComponent || null,
        b: b,
        l: l,
        vertical: true,
        isLoggedIn: isLoggedIn,
        meEmailMigrationData: meEmailMigrationData,
        onToggleDoNotShowAgain: onToggleDoNotShowAgain,
        me: me
      }))));
    }
  }]);
}(Component);
MobileNavigation.propTypes = {
  me: PropTypes.object,
  options: PropTypes.array.isRequired,
  menuOptions: PropTypes.array,
  b: PropTypes.number,
  l: PropTypes.number,
  linkComponent: PropTypes.func,
  comp: PropTypes.func
};

export { MobileNavigation, MobileNavigation as default };
